import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMeal} from '../../domain/saved-meal';
import type {CreateSavedMealInput, SavedMealRepository} from '../ports/saved-meal.repository';

export class CreateSavedMeal implements UseCase<[CreateSavedMealInput], SavedMeal> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(input: CreateSavedMealInput): Promise<Result<SavedMeal, SavedMealError>> {
    return this.repository.create(input);
  }
}
